import React, { useContext } from 'react';
import { makeStyles } from 'tss-react/mui';
import classNames from 'classnames';
import { instrumentsConfig } from '../Instrument.config';
import { TranscriptionDialogContext } from '../../../../../../context';

const useStyles = makeStyles()((theme) => ({
  multiInstrumentsGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, 1fr)',
    gap: '2px',
  },
  allInstrumentsSelected: {
    padding: '2.5px',
    border: `2px solid ${theme.palette.primary.light}`,
  },
  instrumentSelected: {
    padding: '2.5px',
    border: `2px solid ${theme.palette.primary.light}`,
  },
}));

export const TranscriptionModeInstrumentsSet: React.FC<{
  arrangement: boolean;
  singleInstrument?: boolean;
}> = ({ arrangement, singleInstrument }) => {
  const { settings } = useContext(TranscriptionDialogContext);
  const instrumentConfig = instrumentsConfig[settings.instruments[0]];
  const { classes } = useStyles();
  return (
    <div
      className={classNames(classes.multiInstrumentsGrid, {
        [classes.allInstrumentsSelected]: arrangement,
      })}
    >
      {!singleInstrument
        && instrumentConfig.otherInstrumentsSet?.map((instrument, index) => (
          // eslint-disable-next-line react/no-array-index-key
          <div key={index.toString()}>{instrument}</div>
        ))}
      {/* placeholder for the grid */}
      {singleInstrument && <span />}
      <span className={classNames(!arrangement && classes.instrumentSelected)}>
        {instrumentConfig.component}
      </span>
    </div>
  );
};
